import { Download } from "lucide-react";
import { DropdownMenuItem } from "@/components/ui/dropdown-menu";
import { toast } from "@/components/ui/use-toast";
import { downloadFileWithProgress } from "api/swr";
import { cdnUrl } from "commons/cdn";

interface DownloadSpineZipMenuItemProps {
  /** 线上 ZIP 地址，无则禁用 */
  zipUrl: string | null | undefined;
  /** 用于本地保存文件名，默认 `{templateId}.zip` */
  templateId?: string;
}

export function DownloadSpineZipMenuItem({
  zipUrl,
  templateId,
}: DownloadSpineZipMenuItemProps) {
  const handleDownloadZip = async () => {
    if (!zipUrl) {
      toast({
        variant: "destructive",
        title: "下载失败",
        description: "没有可下载的 ZIP 文件",
      });
      return;
    }
    try {
      const blob = await downloadFileWithProgress(cdnUrl(zipUrl), {
        timeout: 90000,
        onProgress: () => {},
      });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `${templateId ?? "spine"}.zip`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    } catch (error) {
      toast({
        variant: "destructive",
        title: "下载失败",
        description: error instanceof Error ? error.message : "未知错误",
      });
    }
  };

  return (
    <DropdownMenuItem onClick={handleDownloadZip} disabled={!zipUrl}>
      <Download className="h-4 w-4 mr-2" />
      下载 Spine ZIP
    </DropdownMenuItem>
  );
}
